import { dashboardPWTypes } from './actionTypes';

const INIT_STATE = {
  filterList: [],
  filterData: {},
  isLoading: false,
  error: {},
};
const DashboardPW = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case dashboardPWTypes.GET_FILTER_LISTPW:
      return {
        ...state,
        isLoading: true,
      };

    case dashboardPWTypes.GET_FILTER_LIST_SUCCESSPW:
      return {
        ...state,
        filterList: action.payload,
        isLoading: false,
      };

    case dashboardPWTypes.GET_FILTER_LIST_FAILPW:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    case dashboardPWTypes.GET_FILTER_DATAPW:
      return {
        ...state,
        isLoading: true,
      };
    case dashboardPWTypes.GET_FILTER_DATA_SUCCESSPW:
      return {
        ...state,
        filterData: action.payload,
        isLoading: false,
      };
    case dashboardPWTypes.GET_FILTER_DATA_FAILPW:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    default:
      return state;
  }
};

export default DashboardPW;
